module.exports = __webpack_public_path__ + "../resources/img/weather_clear-day.bfce7577.svg";